export default {
  "content": "<path d=\"M5.252 13.188l-3.945-3.093L0 11.65 5.55 16 18 1.266 16.393 0z\" fill=\"#fa4338\"/>",
  "attrs": {
    "height": "16",
    "viewBox": "0 0 18 16",
    "width": "18",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};